import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const ArrowUpwardIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="arrow-up" {...props} />;
};

export { ArrowUpwardIcon };
